import { useTranslations } from "next-intl";

import {
  type TLoginWithCodeInputProps,
  type TLoginWithCodeSubmitProps,
} from "./LoginWithCode.config";
import {
  getLoginWithCodeInputProps,
  getLoginWithCodeMessages,
  getLoginWithCodeSubmitProps,
} from "./LoginWithCode.utils";

export const useLoginWithCode = (
  {
    code,
    submit,
  }: {
    code: TLoginWithCodeInputProps;
    submit: TLoginWithCodeSubmitProps;
  },
) => {
  const t = useTranslations("Libs.UI.Components.LoginWithCode");
  const messages = getLoginWithCodeMessages(t);
  const resolvedSubmit = getLoginWithCodeSubmitProps(submit, messages);

  return {
    codeProps: getLoginWithCodeInputProps(code, messages),
    submitLabel: resolvedSubmit.label,
    submitProps: resolvedSubmit.props,
  };
};
